module.exports = __webpack_public_path__ + "img/a4.f407649a.png";